import React, { useState, useEffect } from 'react';
import axios from 'axios';
import configuration from '../config/configuration.json';
import ConsumoTopTitle from '../components/ConsumoTopTitle';
import ConsumoTopButtons from '../components/ConsumoTopButtons';
import ConsumoTable from '../components/ConsumoTable';
import ConsumoMobile from '../components/ConsumoMobile';
import Preloader from '../components/Preloader';
import starIcon from '../img/breadcrumb-list-start-icon.svg';
import { useMediaQuery } from 'react-responsive';

const Consumo = () => {
	const isMobileToTablet = useMediaQuery({ minWidth: '20em', maxWidth: '46.24em' });
	const isFromTablet = useMediaQuery({ minWidth: '46.25em' });

	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState(null);
	const [data, setData] = useState(null);

	useEffect(() => {
		const controller = new AbortController();

		const fetchData = async () => {
			try {
				const response = await axios.get(
					process.env.REACT_APP_URL_API + configuration.GET_LAST_FERIA,
					{ signal: controller.signal }
				);
				if (response.data && response.data.data) {
					console.log("Datos recibidos:", response.data.data);
					setData(response.data.data);
				} else {
					throw new Error("El formato de los datos recibidos no es válido.");
				}
			} catch (err) {
				if (!axios.isCancel(err)) {
					setError(err);
					console.error("Error al obtener los datos:", err);
				}
			} finally {
				setIsLoading(false);
			}
		};

		fetchData();

		return () => {
			controller.abort();
		};
	}, []);

	if (isLoading) {
		return (
			<div className="lottie-loading">
				<Preloader />
			</div>
		);
	}

	if (error) {
		return (
			<div className="consumoContainer">
				<div className="consumoContent error-message">
					<h2>Oops! 😥</h2>
					<p>Hubo un problema al cargar la información. Por favor, intenta de nuevo más tarde.</p>
					<p>Error: {error.message}</p>
				</div>
			</div>
		);
	}

	return (
		<div className="consumoContainer">

			<div className="consumoContent">
				<div class="breadcrumb-section four ng-scope">
					<div class="row">
						<div class="col-lg-12">
							<div class="banner-content">
								<ul class="breadcrumb-list">
									<li><img src={starIcon} style={{ marginRight: '5px' }} /><a href="https://elrodeo.muumercadoganadero.com/">Inicio</a></li>
									<li>Consumo</li>
								</ul>
								<h1>Ferias de Consumo</h1>
							</div>
						</div>
					</div>
				</div>
				<ConsumoTopButtons />

				<div className="consumoDataContent">
					<h2>INFORME DE FERIA</h2>
				</div>

				{data?.locationResume && (
					<div className="contentDataTableContainer">
						{isMobileToTablet && <ConsumoMobile calculationType={"cant"} dataTable={data.locationResume} />}
						{isFromTablet && <ConsumoTable calculationType={"cant"} dataTable={data.locationResume} />}
					</div>
				)}

				<div className="consumoDataContent">
					<h2>Resumen general EL RODEO S.A</h2>
					<h3 className="noTextDecoration">Cuadro de Precios</h3>
				</div>

				{data?.priceResume && (
					<div className="contentDataTableContainer mb-3">
						{isMobileToTablet && <ConsumoMobile calculationType={"cant"} dataTable={data.priceResume} />}
						{isFromTablet && <ConsumoTable calculationType={"cant"} dataTable={data.priceResume} />}
					</div>
				)}
			</div>
		</div>
	);
}

export default Consumo;
